import React, { useMemo, useRef, useState } from 'react';
import ServiceMenu from './ServiceMenu';
import Title from '../Title';
// import SearchBar from '../../../components/SearchBar';
import ServicesSection from './ServicesSection';
import {
    ComplementaryServiceCategoryState,
    ComplementaryServiceTypeState,
    ServiceState,
} from '../../../../types/properties/propertyTypes';
import Card from '../../../../muiComponents/Card';
import { Alert, AlertTitle } from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';

interface ServicesProps {
    titleServices: string;
    titlePage: string;
    selectedServices: ServiceState[];
    optionsCategories: ComplementaryServiceCategoryState[];
    options: ComplementaryServiceTypeState[];
    onClickService: (collectionKey: 'services', service: ServiceState) => void;
}
export default function Services(props: ServicesProps) {
    const {
        titlePage,
        titleServices,
        selectedServices,
        optionsCategories,
        options,
        onClickService,
    } = props;

    const translate = useTranslate();

    // const [searchValue, setSearchValue] = useState('');

    // const handleSearchChange = (value: string) => {
    //     setSearchValue(value);
    // };

    const [visibleCategory, setVisibleCategory] = useState(0);

    const handleVisibleCategory = (idCategory: number) => {
        setVisibleCategory(idCategory);
    };

    const freeCategoryServices = useMemo(() => {
        return options.filter(
            service =>
                service.free && service.idServiceCategory === visibleCategory
        );
    }, [options, visibleCategory]);

    const supplementedCategoryServices = useMemo(() => {
        return options.filter(
            service =>
                !service.free && service.idServiceCategory === visibleCategory
        );
    }, [options, visibleCategory]);

    const initialServices = useRef(selectedServices);
    const freeHotelServices = useMemo(() => {
        // initial services plus the ones added by the user
        return [
            ...selectedServices.filter(
                service => service.__isAdded && service.free
            ),
            ...initialServices.current.filter(service => service.free),
        ];
    }, [selectedServices]);

    const supplementedHotelServices = useMemo(() => {
        // initial services plus the ones added by the user
        return [
            ...selectedServices.filter(
                service => service.__isAdded && !service.free
            ),
            ...initialServices.current.filter(service => !service.free),
        ];
    }, [selectedServices]);

    return (
        <div className='service__container'>
            <ServiceMenu
                titleServices={titleServices}
                optionsCategories={optionsCategories}
                idSelectedMenuItem={visibleCategory}
                onItemClick={handleVisibleCategory}
            />
            <div className='width100perc height100perc flex flex-center'>
                <div className='property-page__content flex-column gap-20'>
                    <Title
                        as='h1'
                        text={titlePage}
                        className='text-align-center'
                    />
                    {/*    <SearchBar
                        placeholder='search'
                        onChange={e => handleSearchChange(e.target.value)}
                        onClear={() => handleSearchChange('')}
                        value={searchValue}
                    /> */}

                    {/* no hay servicios seleccionados y no estás dentro de ninguna categoría */}
                    {!visibleCategory &&
                    !freeHotelServices.length &&
                    !supplementedHotelServices.length ? (
                        <Card className='padding20'>
                            <Alert severity='info'>
                                <AlertTitle sx={{ fontWeight: 'bold' }}>
                                    {translate('services_text_title')}
                                </AlertTitle>
                                <p style={{ fontWeight: 'normal' }}>
                                    {translate('services_text_subtitle')}
                                </p>
                            </Alert>
                        </Card>
                    ) : (
                        <>
                            <ServicesSection
                                title='free'
                                servicesList={
                                    visibleCategory
                                        ? freeCategoryServices
                                        : freeHotelServices
                                }
                                selectedServices={selectedServices}
                                color={'blue'}
                                onClickService={onClickService}
                            />
                            <ServicesSection
                                title='with_supplement'
                                servicesList={
                                    visibleCategory
                                        ? supplementedCategoryServices
                                        : supplementedHotelServices
                                }
                                selectedServices={selectedServices}
                                color={'purple'}
                                onClickService={onClickService}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
